import { useMemo } from "react";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import useFeature from "hooks/useFeature";
import { UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
const useFieldTypesUnits = () => {
  const isFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const { data, isLoading } = useFieldTypes(void 0, void 0, isFeatureEnabled);
  return useMemo(() => {
    var _a;
    if (isLoading) return {};
    return Object.fromEntries((_a = data == null ? void 0 : data.filter((ft) => {
      var _a2;
      return (_a2 = ft == null ? void 0 : ft.unit) == null ? void 0 : _a2.isDefined;
    }).map((ft) => [ft.name, ft.unit])) != null ? _a : []);
  }, [data, isLoading]);
};
export default useFieldTypesUnits;
